// @ts-nocheck
import { config } from 'utils/config';

export const statusOptions = [
    { name: 'Bestilt', value: 'ordered' },
    { name: 'Første møde', value: 'firstMeeting' },
    { name: 'Andet møde', value: 'secondMeeting' },
    { name: 'Tredje møde', value: 'thirdMeeting' },
    { name: 'Færdig', value: 'completed' },
    { name: 'På pause', value: 'onHold' },
    { name: 'Annulleret', value: 'cancelled' },
    { name: 'Refunderet', value: 'refunded' },
];

// Organisations with this feature enabled use the status flow with dialogs and status history.
export const ORDER_STATUS_FLOW_FEATURE = 'order-status-flow';

export const statusFlowOptions = [
    { name: 'Bestilt', value: 'ordered' },
    { name: 'Følg op på senere', value: 'followUp' },
    { name: 'Afsluttet', value: 'completed' },
    { name: 'Annulleret', value: 'cancelled' },
    { name: 'Ikke blevet til salg', value: 'notSold' },
];

const STATUS_FLOW_TEST_ORGANISATIONS = ['TealAdvice'];
const isTestEnvironment = env => ['test', 'local'].includes(env);

export const hasOrderStatusFlow = (organisation, env = config.env) => (
    Boolean(organisation?.enabledFeatures?.includes(ORDER_STATUS_FLOW_FEATURE))
    || (isTestEnvironment(env) && STATUS_FLOW_TEST_ORGANISATIONS.includes(organisation?.organisationId))
);

export const getStatusOptions = organisation => (hasOrderStatusFlow(organisation) ? statusFlowOptions : statusOptions);

export const getStatusName = (value, organisation) => (
    [...getStatusOptions(organisation), ...statusOptions, ...statusFlowOptions].find(status => status.value === value)?.name || value
);

export const notSoldReasonOptions = [
    { name: 'Det var for dyrt', value: 'tooExpensive' },
    { name: 'Der var ingen mulighed for optimering for kunden', value: 'noOptimisation' },
    { name: 'Kunden var ikke interesseret', value: 'notInterested' },
    { name: 'Andet', value: 'other' },
];

// export const advisorOptions = [
//     { name: 'Advisor 1', value: 'advisor1' },
//     { name: 'Advisor 2', value: 'advisor2' },
//     { name: 'Advisor 3', value: 'advisor3' },
// ];
export const legalProducts = [
    { name: 'Gennemgang af testamente', value: 'existing-testament' },
    { name: 'Testamente', value: 'new-testament' },
    { name: 'Familiejura Gennemgang', value: 'family-jura' },
    { name: 'Ægtepagt', value: 'prenuptial-agreement' },
    { name: 'Fremtidsfuldmagt', value: 'power-of-attorney' },
];
export const financialProducts = [
    { name: 'ØkonomiTjek', value: 'economy-advisory-full' },
    { name: 'PensionsTjek gennemgang', value: 'pension-advisory-pensioncheck' },
    { name: 'Nedsparingsrådgivning', value: 'pension-advisory-full' },
    { name: 'Pensionsrådgivning', value: 'pension-advisory-hourlyrate' },
    { name: 'Danske bank lånvalidering', value: 'danske-bank-loan-validation' },
];

export const accessOrderSelectableProductIds = new Set([
    'danske-bank-loan-validation',
]);
